/*
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

import OnPostloadDone from "@/libs/data-api-postloader/OnPostloadDone";
import DataApiPostloader from "@/libs/DataApiPostloader";

export default class OnPostloadDoneHandler {
  private _handlers: OnPostloadDone[];

  constructor() {
    this._handlers = [];
  }

  add(handler: OnPostloadDone) {
    if (handler === undefined || handler === null) {
      return;
    }
    this._handlers.push(handler);
  }

  handle(data?: any, instance?: DataApiPostloader) {
    this._handlers.forEach((handler) => {
      handler(data, instance);
    });
  }
}
